import * as React from 'react';

function SvgToggle2On(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M7 5H3a3 3 0 000 6h4a4.995 4.995 0 01-.584-1H3a2 2 0 110-4h3.416c.156-.357.352-.692.584-1z' />
			<path d='M16 8A5 5 0 116 8a5 5 0 0110 0z' />
		</svg>
	);
}

export default SvgToggle2On;
